import { render, staticRenderFns } from "./AnalyticsViewsPerPagePath.vue?vue&type=template&id=5645d539"
import script from "./AnalyticsViewsPerPagePath.vue?vue&type=script&lang=js"
export * from "./AnalyticsViewsPerPagePath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports